import { FC } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { Status } from "./StepStatus";
import { CheckCircle } from "untitledui-js-base";

export const Card: FC<{
  title: string;
  description?: string;
  onClick?: () => void | unknown;
  status?: string;
  icon?: React.ReactNode;
  buttonText?: string;
  stepCompleted?: boolean;
}> = ({
  title,
  description,
  onClick,
  status,
  icon,
  buttonText,
  stepCompleted
}) => {
  return (
    <div className="mx-auto mb-4 w-full max-w-[420px] rounded-lg border border-alpha-100 bg-background-1000 p-6 shadow-lg">
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          {stepCompleted ? (
            <CheckCircle size="20" className="stroke-success-700" />
          ) : null}
          <p className="text-base font-bold text-content-1000">{title}</p>
        </div>
        {status &&
        // Hide under review badge for identity verification
        !(status === "pending" && title === "Identity verification") ? (
          <Status status={status} />
        ) : null}
        {icon ? icon : null}
      </div>
      {stepCompleted ? null : (
        <>
          <p className="mt-4 whitespace-pre-line text-sm text-content-400">
            {description}
          </p>
          <div className="my-4 border-b border-alpha-40" />
          <Button
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.BASE}
            className="w-full"
            onClick={onClick}
          >
            {buttonText ? buttonText : "Start"}
          </Button>
        </>
      )}
    </div>
  );
};
